export class DeviceStatesPromisesQueue {
    queue: boolean[] = [];
    isRunning = false;
    previousState: boolean | undefined = undefined;
    timerId = 0;

    constructor(
        private readonly resolver: (state: boolean) => Promise<any>,
        private readonly delay = 300
    ) {
    }

    add(state: boolean) {
        window.clearTimeout(this.timerId);
        return new Promise((res) => {
            this.timerId = window.setTimeout(async () => {
                this.queue.push(state);
                if (!this.isRunning) {
                    await this.run();
                    res(null);
                }
            }, this.delay)
        })
    }

    pop(): (boolean) | undefined {
        return this.queue.shift();
    }

    async run() {
        this.isRunning = true;

        let currentState = this.pop();

        while (currentState !== undefined) {
            try {
                if (this.previousState != currentState) {
                    this.previousState = currentState;
                    await this.resolver(currentState);
                }
            }
            finally {
                currentState = this.pop();
            }
        }

        this.isRunning = false;
    }
}